import { extname } from 'path';

export const fileTypeByName = (filename: string) => {
  let ext = extname(filename).toLowerCase();
  if (ext.length > 1) {
    ext = ext.substr(1);
  }
  switch (ext) {
    case 'css':
      return 'css';
    case 'html':
      return 'html'
    case 'js':
    case 'ts':
      return 'js';
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'svg':
      return 'image';
    case 'ttf':
    case 'woff':
    case 'woff2':
    case 'eot':
      return 'font';
    default:
      return 'other';
  }
}
